export const guestBookingService = "1d9948be39df4a318d78b65b9f8093b7200a3e99ca90f19fba669edc501b8146";